import { Routes } from '@angular/router';
import { Login } from './components/core/login/login';
import { ResetPassword } from './components/core/reset-password/reset-password';
import { Security } from './components/core/security/security';
import { authGuard } from './guards/auth.guard';
import { Printpdf } from './components/reports/printpdf/printpdf';

export const routes: Routes = [
  { path: '', component: Login },
  { path: 'login', component: Login }, // alias for external apps using /login?token=
  { path: 'reset-password/:code', component: ResetPassword },
  { path: 'print/:documentId', component: Printpdf },
  { path: 'security', component: Security, canActivate: [authGuard] },
  {
    path: 'reports',
    loadChildren: () => import('./features/reports/reports.routes').then(m => m.reportsRoutes)
  },
  {
    path: 'admin',
    loadChildren: () => import('./features/admin/admin.routes').then(m => m.adminRoutes)
  },
  {
    path: 'eeszt',
    loadChildren: () => import('./features/eeszt/eeszt.routes').then(m => m.eesztRoutes)
  },
];
